export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;
export const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: 'rgba(0, 0, 0, 0.1)',
  boxShadow: isDragging ? '0px 2px 4px rgba(0, 0, 0, 0.3)' : '',

  // styles we need to apply on draggables
  ...draggableStyle,
});

export const getListStyle = (isDraggingOver) => ({
  border: '1px solid #c8ced3',
  padding: grid,
  width: '100%',
});

export const getDraggedDom = (draggableId) => {
  const queryAttr = 'data-rbd-draggable-id';
  const domQuery = `[${queryAttr}='${draggableId}']`;
  const draggedDOM = document.querySelector(domQuery);

  return draggedDOM;
};

export const getDestinationDom = (dropabbleId) => {
  const destinationQuertAttr = 'data-rbd-droppable-id';
  const domQuery = `[${destinationQuertAttr}='${dropabbleId}']`;
  const destinationDOm = document.querySelector(domQuery);
  return destinationDOm;
};
